import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';

import {
    RemoveCatalogItemRequestBody,
    RemoveCatalogItemResponse,
} from '../types/RemoveCatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const removeCatalogItemService = createAsyncThunk<
    RemoveCatalogItemResponse,
    RemoveCatalogItemRequestBody,
    ThunkConfig<any>
>(
    'catalogItem/removeFromCatalog',
    async ({ data, catalogId, isSingle, suppressToast }, thunkApi) => {
        const { extra, rejectWithValue, dispatch } = thunkApi;

        try {
            const response = await extra.api.delete<RemoveCatalogItemResponse>(
                `/v1/catalogs/${catalogId}/items`,
                { data },
            );

            const dataToRemove = response.data.removed.map(
                (item) => item.itemUuid,
            );

            if (isSingle) {
                if (dataToRemove.length) {
                    dispatch(
                        catalogItemActions.removeSingleItemByUidFromSelection(
                            dataToRemove[0],
                        ),
                    );
                }

                dispatch(catalogItemActions.closeDetailedItem());
            } else {
                dispatch(catalogItemActions.removeAllSelection());
            }

            dispatch(catalogItemActions.removeMultipleItemsByUid(dataToRemove));

            if (!suppressToast) {
                toast(
                    isSingle
                        ? 'Item removed from catalog'
                        : 'Items removed from catalog',
                );
            }

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
